import { Storage } from '@ionic/storage';

export class IonicStorageWrapper {
   private storage: Storage;

    constructor(storage: Storage) {
     this.storage = storage;
   }

    getItem(key: string): string | Promise<string | null> | null {
     return this.storage.get(key);
   }

    removeItem(key: string): void | Promise<void> {
     return this.storage.remove(key);
   }

    // Swallowing here is deliberate: the persistor rethrows a write failure into an
    // unawaited callback, so an uncaught quota error surfaced only as a rejection.
    setItem(key: string, value: string): void | Promise<void> {
     return this.storage.set(key, value).catch((error: unknown) => {
       console.error(`IonicStorageWrapper failed to write "${key}":`, error);
     });
   }
}
